function DarkThemeIcon() {
  return (
    <span className="anticon anticon-darktheme">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="190"
        height="137"
        fill="none"
        viewBox="0 0 190 137"
      >
        <rect
          width="189"
          height="136"
          x="0.5"
          y="0.5"
          fill="#1B2028"
          stroke="#ECEEF5"
          rx="4.5"
        />
        <path fill="#080A0B" d="M54 136h132a3 3 0 003-3V14H54v122z" />
        <g filter="url(#filter0_d_705_60677)">
          <path
            fill="#1B2028"
            d="M1 11C1 5.477 5.477 1 11 1h168c5.523 0 10 4.477 10 10v4H1v-4z"
          />
        </g>
        <path fill="#2E343F" d="M1 14a1 1 0 001 1h186a1 1 0 001-1H1z" />
        <path fill="#1B2028" d="M16 136H4a3 3 0 01-3-3V15h15v121z" />
        <path fill="#2E343F" d="M16 136a1 1 0 01-1-1V15h1v121z" />
        <circle cx="6" cy="8" r="2" fill="#CC6B65" />
        <circle cx="13" cy="8" r="2" fill="#FDBF00" />
        <circle cx="20" cy="8" r="2" fill="#51A121" />
        <rect width="24" height="6" x="59" y="20" fill="#27303B" rx="1" />
        <rect width="5" height="5" x="6" y="20" fill="#E2F6FF" rx="1" />
        <rect width="27" height="5" x="21" y="20" fill="#27303B" rx="1" />
        <rect width="5" height="5" x="6" y="29" fill="#E2F6FF" rx="1" />
        <rect width="27" height="5" x="21" y="29" fill="#27303B" rx="1" />
        <rect width="5" height="5" x="6" y="38" fill="#E2F6FF" rx="1" />
        <rect width="27" height="5" x="21" y="38" fill="#27303B" rx="1" />
        <rect width="5" height="5" x="6" y="47" fill="#E2F6FF" rx="1" />
        <rect width="27" height="5" x="21" y="47" fill="#27303B" rx="1" />
        <rect width="5" height="5" x="6" y="56" fill="#E2F6FF" rx="1" />
        <rect width="27" height="5" x="21" y="56" fill="#27303B" rx="1" />
        <rect width="5" height="5" x="6" y="65" fill="#E2F6FF" rx="1" />
        <rect width="27" height="5" x="21" y="65" fill="#27303B" rx="1" />
        <rect width="5" height="5" x="6" y="74" fill="#E2F6FF" rx="1" />
        <rect width="27" height="5" x="21" y="74" fill="#27303B" rx="1" />
        <g filter="url(#filter1_d_705_60677)">
          <rect width="40" height="16" x="59" y="31" fill="#1B232E" rx="1" />
        </g>
        <rect width="4" height="4" x="62" y="34" fill="#88959B" rx="1" />
        <rect width="34" height="4" x="62" y="40" fill="#27303B" rx="1" />
        <g filter="url(#filter2_d_705_60677)">
          <rect width="125" height="80" x="59" y="52" fill="#1B232E" rx="1" />
        </g>
        <g filter="url(#filter3_d_705_60677)">
          <rect width="40" height="16" x="102" y="31" fill="#1B232E" rx="1" />
        </g>
        <rect width="4" height="4" x="105" y="34" fill="#88959B" rx="1" />
        <rect width="34" height="4" x="105" y="40" fill="#27303B" rx="1" />
        <g filter="url(#filter4_d_705_60677)">
          <rect width="40" height="16" x="144" y="31" fill="#1B232E" rx="1" />
        </g>
        <rect width="4" height="4" x="147" y="34" fill="#88959B" rx="1" />
        <rect width="34" height="4" x="147" y="40" fill="#27303B" rx="1" />
        <rect width="21" height="4" x="62" y="55" fill="#252E39" rx="1" />
        <rect width="21" height="4" x="62" y="75" fill="#252E39" rx="1" />
        <rect width="21" height="4" x="62" y="95" fill="#252E39" rx="1" />
        <rect width="21" height="4" x="123" y="55" fill="#252E39" rx="1" />
        <rect width="21" height="4" x="123" y="75" fill="#252E39" rx="1" />
        <rect width="58" height="7" x="62" y="61" fill="#27303B" rx="2" />
        <rect width="58" height="7" x="62" y="81" fill="#27303B" rx="2" />
        <rect width="119" height="28" x="62" y="101" fill="#27303B" rx="2" />
        <rect width="58" height="7" x="123" y="61" fill="#27303B" rx="2" />
        <rect width="58" height="7" x="123" y="81" fill="#27303B" rx="2" />
        <defs>
          <filter
            id="filter0_d_705_60677"
            width="190"
            height="16"
            x="0"
            y="1"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="0.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_705_60677"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_705_60677"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_705_60677"
            width="44"
            height="20"
            x="57"
            y="30"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_705_60677"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_705_60677"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d_705_60677"
            width="129"
            height="84"
            x="57"
            y="51"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_705_60677"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_705_60677"
              result="shape"
            />
          </filter>
          <filter
            id="filter3_d_705_60677"
            width="44"
            height="20"
            x="100"
            y="30"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_705_60677"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_705_60677"
              result="shape"
            />
          </filter>
          <filter
            id="filter4_d_705_60677"
            width="44"
            height="20"
            x="142"
            y="30"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_705_60677"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_705_60677"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </span>
  );
}

export default DarkThemeIcon;
